module.exports = __webpack_public_path__ + "static/media/Hair01.89fb38d3.jpeg";